'use strict';

/* eslint-disable */
// Require optional shared components
require(['componentLoader'], function (helper) {

  // This site's module parameters
  helper.updateConfig({
    ajaxBasket: {
      excludeTick: true,
      recommendationsParentClass: 'recommendations-section',
      recommendationsHeaderClass: 'heading',
      recommendationsClass: 'item',
      recommendationsHeaderEncloseElement: 'h3',
      maxRecommendations: 4,
      thumbnailImageSize: 'large'
    },
    imageZoom: {
      bx_mode: 'horizontal',
      bx_controls: false,
      bx_pause: 4000,
      bx_infiniteLoop: false,
      bx_displaySlideQty: 4,
      bx_moveSlideQty: 4,
      bx_startingSlide: 0,
      bx_slideWidth: 150,
      bx_hideControlOnEnd: false
    },
    dealsCountdown: {
      endHour: 24,
      weekends: true
    }
  });

  // Make these modules dependencies
  helper.promote(['buyingRightNow', 'carouselSet', 'countrySwitcher', 'CurrencySelection', 'editorialVideoScript', 'fancyBoxVideo', 'konamiCodeTemplate', 'productFollow', 'royalSliderPlus', 'sliderSet', 'videoObject', 'videoObjectTemplate', 'widgetControls']);

  // Add new shims
  helper.updateShim({
    facetTpl: {
      deps: ['handlebars'],
      exports: 'facetUpdateTpl'
    }
  });

  helper.requireDependencies();
});

define(['jquery', 'siteObj', '$location', 'common', 'expander', 'fancyBox', 'hint', 'royalslider', 'mtabs', 'popup'], function ($, siteObj, $location) {

  var zvint = {

    _initYouTube: function _initYouTube() {
      /* Youtube videos /videos/youtube-main.js - load the API and render via youtubePlayer */
      require(['youtube'], function (youtube) {
        youtube('.js-youtube-video').done(function () {
          // ytVideosArray: array of Youtube videos and player Api controls for further
          // customisation

          var activeYTThumbClass = 'widget-youtube__gallery__menu__items__item--active';
          $('.youtube-video__gallery__menu__item').on('click', function () {
            $('.youtube-video__gallery__menu__item').removeClass(activeYTThumbClass);
            $(this).addClass(activeYTThumbClass);
          });
        });
      });
    },

    _initCodes: function _initCodes($doc, bodyWrap, $body) {
      /*** CODES ***/

      require(['codes', 'konamiCodeTemplate'], function (codes, konamiCodeTemplate) {

        function codeOverlay(offer) {
          bodyWrap.prepend(konamiCodeTemplate({
            konami: {
              offer: offer
            }
          }));

          var specialOffer = $('.konami-offer, .konami-overlay'),
              konamiClick = $('.konami-close, .konami-overlay');
          specialOffer.stop().fadeIn(500);

          $doc.keydown(function (e) {
            if (e.keyCode === 27) {
              $doc.unbind('keydown');
              specialOffer.click();
            }
          });

          konamiClick.on('click', function () {
            specialOffer.stop().fadeOut(500);
            setTimeout(function () {
              specialOffer.remove();
            }, 600);
          });
        }

        codes.codeCall.konamiCode = function () {
          var offer = 'You\'re awesome!';
          codeOverlay(offer);
        };

        codes.codeCall.numberWang = function () {
          var offer = 'That\'s number wang!';
          codeOverlay(offer);
        };

        codes.codeCall.spinRight = function () {
          $body.addClass('washing-machine-right');
          setTimeout(function () {
            $body.removeClass('washing-machine-right');
          }, 1100);
        };

        codes.codeCall.chaChaSlide = function () {
          $body.addClass('cha-cha-slide');
          setTimeout(function () {
            $body.removeClass('cha-cha-slide');
          }, 1100);
        };

        codes.levelUp(codes);
      });

      /*** END OF CODES ***/
    },

    _initResize: function _initResize(mediaMatch, bodyWrap) {
      /*** WINDOW RESIZE AND MEDIA QUERY FALLBACK ***/
      if (typeof mediaMatch === 'undefined') {
        window.onresize = function () {
          zvint._mediaTablet(bodyWrap);
        };
        zvint._mediaTablet(bodyWrap);
      }

      /*** END OF WINDOW RESIZE AND MEDIA QUERY FALLBACK ***/
    },

    _initRoyalSliderPlus: function _initRoyalSliderPlus() {
      /*** ROYAL SLIDER PLUS ***/

      require(['royalSliderPlus', 'sliderSet', 'carouselSet', 'productSkuWidget'], function (royalSliderPlus, sliderSet, carouselSet, productSkuWidget) {
        var royalSlider = [];

        // Add royal slider data to array
        royalSlider.push(sliderSet);
        royalSlider.push(carouselSet);
        royalSlider.push(productSkuWidget);

        // Change to false to disable royal slider plus functionality
        royalSliderPlus.init(true, royalSlider);
      });

      /*** END OF ROYAL SLIDER PLUS ***/
    },

    _initTabChart: function _initTabChart() {
      /*** TABS (Tom Tabs) ***/

      require(['tabs'], function (tabs) {
        tabs.init({
          $globalTabs: $('.tabbed-chart-container'),
          tabHeading: '.chart-heading',
          tabBody: '.tab-body',
          speed: 400
        });
      });

      /*** END OF TAB CHART ***/
    },

    _initBannerWidgets: function _initBannerWidgets($bannerLinks) {
      //for putting links inside widget banners
      $bannerLinks.find('.btn[data-href], .product-sku-link[data-href]').click(function () {
        $location.href = $(this).attr('data-href');
        return false;
      });
    },

    _initCountdownTimer: function _initCountdownTimer() {
      //countdown timer
      if ($('.countdown-timer').length) {
        if (siteObj.type === 'list') {
          requirejs.s.contexts._.config.paths.countdown = 'modules/mikountdown';
          require(['modules/dealscountdown'], function (c) {
            c.initDealsCountdown();
          });
        }
      }
    },

    _initIE8ish: function _initIE8ish() {
      // adding a pipe for "sort by" sections in IE6-8

      /** @namespace isIE8Ish */
      if (window.isIE8Ish === true) {
        $('.sort-by-options .l-unit:not(.first):not(:last-child)').after(' | ');
      }
    },

    _initCurrencySelector: function _initCurrencySelector() {
      //Currency Selector Behaviours
      require(['CurrencySelection'], function (CurrencySelection) {
        window.cSelect = new CurrencySelection('li.currency');
      });
    },

    _initHelpSitePopup: function _initHelpSitePopup($body) {
      // help site pop up
      $body.on('click', 'a[href^=\'http://help.zavvi.com\'], a[href^=\'http://ayuda.zavvi.es\'], a[href^=\'http://help.zavvi.nl\']', function (e) {
        var helpurl = $(this).attr('href');

        // check if there are query string parameters in the link already
        if (helpurl.indexOf('?') === -1) {
          helpurl += '?';
        } else {
          helpurl += '&';
        }

        if (siteObj.customerLocale === 'en_US' || siteObj.customerLocale === 'en_AU') {
          // lang and locale value for overriding 2 digit locals
          helpurl += 'lang=' + siteObj.selectedLang + '-' + siteObj.countryCode;
        } else {
          // lang value only
          helpurl += 'lang=' + siteObj.selectedLang;
        }
        window.open(helpurl, '', 'height=800,scrollbars=yes,width=785', false);
        e.preventDefault() ? e.preventDefault() : false;
      });
    },

    _initTooltipPopups: function _initTooltipPopups() {
      //initialize tooltip  popups
      if ($().popover) {
        $('.lbl-help').popover({
          trigger: 'manual'
        }).hover(function () {
          //trigger the popover manually to allow us to set a timer to keep it open
          $('.lbl-help').popover('hide'); // hide all open popups
          $(this).popover('show'); //show current one
        }).mouseleave(function () {
          setTimeout('$(\'.popover\').hide()', 2000); //hide popup after 2 seconds
        });
      }
    },

    _initTabs: function _initTabs(tabs) {
      // Enables Matt Tabs on Product Page
      tabs.each(function () {
        var $this = $(this);
        $this.mtabs({
          tab_text_el: 'h3'
        });
      });
    },

    _initProductReview: function _initProductReview(scoreHolderCheck, $chartHolder, $chartBars) {
      /*** PRODUCT REVIEW ANIMATION ***/
      if (scoreHolderCheck) {
        $chartBars.addClass('no-transition').css({
          width: 0
        });
        zvint._chartBarCheck($chartHolder, $chartBars);
      }
      /*** END OF PRODUCT REVIEW ANIMATION ***/
    },

    _initMediaVideo: function _initMediaVideo() {
      var $mediaGallery = $('.child-video-wrap'),
          $mediaChildren = $mediaGallery.find('.media-content');

      $mediaChildren.click(function () {
        var $this = $(this),
            videoUrl = $this.find('.main-video-nav').attr('href');

        requirejs.config({
          paths: {
            videoObjectTemplate: 'templates/video-object'
          }
        });

        require(['videoObjectTemplate'], function () {
          var template = Handlebars.templates['video-object'](videoUrl);
          $('.main-video-wrap').html(template);
        });

        return false;
      });
    },

    _initListPageVariations: function _initListPageVariations($body, initial_fb_content) {
      // Handle list page variations products.
      if ($body.hasClass('list') || $body.hasClass('dept') || $body.hasClass('searchlist') || $body.hasClass('product')) {
        $body.on('click', '.quickview, .quickview-buy', function () {

          var contents,
              page_url = $(this).attr('href'),
              fb_opts = {
            afterShow: function afterShow() {
              // Bind close events
              $('.product-quick-view').delegate('.close-fb', 'click', function (e) {
                $.fancybox.close();
                e.preventDefault();
              });
            },
            beforeClose: function beforeClose() {
              $('.product-quick-view').undelegate('.close-fb');
            }
          };

          siteObj.productID = $(this).closest('.item').attr('rel');

          if ($().fancybox) {
            $.fancybox(initial_fb_content, $.extend({
              'closeBtn': false
            }, fb_opts));
          }

          $.ajax({
            url: page_url,
            data: 'ajax=true',
            dataType: 'html',
            success: function success(result) {
              contents = quickView(result, page_url);
              $.fancybox.close();
              $.fancybox(contents, $.extend({
                'closeBtn': false
              }, fb_opts));

              $('.fancybox-inner').fadeIn('400', function () {
                if ($('input[name=\'cheapest-product-id\']').length) {
                  siteObj.fn.basket.preselected_product = true;
                }
                $('.buying-area button[disabled=\'disabled\']').removeAttr('disabled').addClass('disabled');
              });
            }
          });
          return false;
        });
      }
    },

    _initProductPage: function _initProductPage($reviewStars, $customerReviews) {
      if (siteObj.type === 'product') {
        var $variationDropDowns = $('.variation-dropdowns');
        if ($variationDropDowns.length > 0 && $('#opts-4').length > 0 && $('ul.colour-swatches-list').length < 1 || $variationDropDowns.length > 0 && $('#opts-2').length > 0) {

          require(['colourswatches'], function (colourswatches) {
            colourswatches.colourSwatchesForSelectBoxWithLabel('opts-4');
            colourPicker();
          });
        }

        // Enables page scrolling to an id on
        $reviewStars.click(function () {
          $('html, body').animate({
            scrollTop: $customerReviews.offset().top - 20
          }, 750);
        });

        // product page PAP popup
        var $promoDesc = $('.product-promo .product-promo-desc'),
            $promo = $promoDesc.length ? $promoDesc.parent() : false;

        if ($promo) {
          $promo.find('h3').css('cursor', 'pointer').click(function () {
            var html = $promo.wrap('<div />').parent().html();
            $.fancybox(html, {
              'width': 400,
              'maxWidth': 400,
              'height': 'auto'
            });
          });
        }
      }
    },

    _initReadMore: function _initReadMore($body) {
      // Read more expand text for department & list pages
      if ($body.is('.dept, .list, .product') && $('div').hasClass('expand-text')) {

        $('.expand-text p, .expand-text span').css('visibility', 'visible'); // To stop the jerky motion when the page is loaded

        $('.expand-text').expander({
          slicePoint: 400,
          preserveWords: true,
          widow: 4,
          expandEffect: 'fadeIn',
          expandSpeed: 400,
          collapseEffect: 'fadeOut',
          collapseSpeed: 400,
          collapseTimer: 0,
          expandPrefix: ''
        });

        // opens product page description when clicking read more on quickview.

        if (siteObj.type === 'product' && $location.hash === '#productOverview') {
          var $readMore = $('.product-info .read-more a');
          $readMore.click();
        }
      }
    },

    _initProductPap: function _initProductPap() {
      // Product page pap override
      var promo = $('.product-promo h3');
      promo.unbind('click').click(function () {
        $location.href = $(this).parent().find('a')[0].href;
      });
    },

    _initDescriptionTab: function _initDescriptionTab() {
      // Set description tab as default
      var $tabs = $('.tabs-menu');
      if ($tabs.length) {
        $tabs.find('li.tab-1 span').click();
      }
    },

    _initFullWidthVideo: function _initFullWidthVideo() {
      // full width vimeo start //
      (function ($) {

        $.fn.fitVids = function (options) {
          var settings = {
            customSelector: null
          };

          if (!document.getElementById('fit-vids-style')) {
            // appendStyles: https://github.com/toddmotto/fluidvids/blob/master/dist/fluidvids.js
            var head = document.head || document.getElementsByTagName('head')[0];
            var css = '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}';
            var div = document.createElement('div');
            div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>';
            head.appendChild(div.childNodes[1]);
          }

          if (options) {
            $.extend(settings, options);
          }

          return this.each(function () {
            var selectors = ['iframe[src*=\'player.vimeo.com\']', 'iframe[src*=\'youtube.com\']', 'iframe[src*=\'youtube-nocookie.com\']', 'iframe[src*=\'kickstarter.com\'][src*=\'video.html\']', 'object', 'embed'];

            if (settings.customSelector) {
              selectors.push(settings.customSelector);
            }

            var $allVideos = $(this).find(selectors.join(','));
            $allVideos = $allVideos.not('object object'); // SwfObj conflict patch

            $allVideos.each(function () {
              var $this = $(this);

              if (this.tagName.toLowerCase() === 'embed' && $this.parent('object').length || $this.parent('.fluid-width-video-wrapper').length) {
                return;
              }

              var height = this.tagName.toLowerCase() === 'object' || $this.attr('height') && !isNaN(parseInt($this.attr('height'), 10)) ? parseInt($this.attr('height'), 10) : $this.height(),
                  width = !isNaN(parseInt($this.attr('width'), 10)) ? parseInt($this.attr('width'), 10) : $this.width(),
                  aspectRatio = height / width;

              if (!$this.attr('id')) {
                var videoID = 'fitvid' + Math.floor(Math.random() * 999999);
                $this.attr('id', videoID);
              }

              $this.wrap('<div class="fluid-width-video-wrapper"></div>').parent('.fluid-width-video-wrapper').css('padding-top', aspectRatio * 100 + '%');
              $this.removeAttr('height').removeAttr('width');
            });
          });
        };
        // Works with either jQuery or Zepto
      })(window.jQuery || window.Zepto);

      $('.landing-vimeo').fitVids();
      // full width vimeo end //
    },

    _initWidgetControls: function _initWidgetControls(supportsTouch) {
      require(['widgetControls'], function (widgetControls) {
        /*** WIDGET CONTROLS ***/

        widgetControls.init({
          $widgets: $('.image-with-text-animate a, .columns-set-brand-feature-2-columns a, .home .columns-set .image-with-text a'),
          $widgetsGlobal: $('.columns-set .column-row:not(.widget-block.editorial .column-row)'),
          wordLimit: 23
        });

        if (supportsTouch) {
          widgetControls.touchControl();
        }

        /*** END OF WIDGET CONTROLS ***/
      });
    },

    _initStickyHeader: function _initStickyHeader($pageContainer, $win, supportsTouch, documentH) {
      require(['stickyHeader'], function (stickyHeader) {
        /*** MAIN NAVIGATION ***/

        if (siteObj.tplPrefix === 'multi-widget-o') {
          return;
        }

        var $oldSiteSwitch = $('#newsite-oldsite');

        stickyHeader.init({
          $pageContainer: $pageContainer,
          // Get site header
          $siteHeader: $('header.header'),
          // Top section of navigation
          $headerTopLinks: $('.header-top-links'),
          // Bottom section of nav with main links wrapper
          $sectionNavigation: $('.section-navagation'),
          // Small logo and menu button wrapper
          $logoSmall: $('.small-screen-logo'),
          // Main top level menu links
          $mainMenuLink: $('.nav-main .nav-item'),
          // Small menu button wrapper
          $smallMenuButton: $('.small-screen-menu'),
          // Tablet control for account dropdown
          $navItemAccount: $('.nav-item-account'),
          // Sub-menu wrapper mainMenuLink.find(string)
          subMenuWrapper: '.submenu-wrap',
          win: $win,
          documentH: documentH,
          speed: {
            navSlideUp: 150,
            logoFadeIn: 500,
            navClickSlide: 150
          },
          // Old site new site switch offset
          offset: $oldSiteSwitch.length ? $oldSiteSwitch.outerHeight(true) : false,
          supportsTouch: supportsTouch
        });

        if (supportsTouch) {
          stickyHeader.touchControl();
        }

        /*** END OF MAIN NAVIGATION ***/
      });
    },

    _initAnchorScroll: function _initAnchorScroll(anchorScrollCheck, $backToTop, $win, supportsTouch, documentH) {
      require(['anchorScroll'], function (anchorScroll) {
        /*** ANIMATED SCROLL ***/

        if (anchorScrollCheck) {
          anchorScroll.init({
            // Back to top button and height
            backToTop: $backToTop,
            win: $win,
            backToTopH: $backToTop.height(),
            // Footer height
            footerH: $('.section-footer').height(),
            // Document height for dynamic calculation
            documentH: documentH,
            gutterMargin: 24,
            backToTopGlobal: false
          });

          // Params: String: Target, Int: Speed, (Optional) Boolean: Top
          anchorScroll.clickScroll('.back-to-top', 650, true);
        }

        /*** END OF ANIMATED SCROLL ***/
      });
    },

    _initWindowScroll: function _initWindowScroll(supportsTouch, anchorScrollCheck, productFollowCheck, scoreHolderCheck, $chartHolder, $chartBars) {
      require(['anchorScroll', 'stickyHeader', 'productFollow'], function (anchorScroll, stickyHeader, productFollow) {
        /*** WINDOW SCROLL AND PAGE LOAD CHECKS ***/

        window.onscroll = function () {
          // check sticky header
          if (!supportsTouch) {
            stickyHeader.windowScroll();
          }
          // check back to top button
          if (anchorScrollCheck) {
            anchorScroll.windowScroll();
          }
          // check product follow
          if (productFollowCheck) {
            productFollow.windowScroll();
          }
          // check element on screen
          if (scoreHolderCheck) {
            zvint._chartBarCheck($chartHolder, $chartBars);
          }
          // old code - close auto-complete search on scroll
          $('.autocomplete-container').hide();
        };

        /*** END OF WINDOW SCROLL AND PAGE LOAD CHECKS ***/
      });
    },

    _initProductFollow: function _initProductFollow(productFollowCheck, $win, $productSlide, $takeover, pageContainerH) {
      require(['productFollow'], function (productFollow) {
        /*** PRODUCT FOLLOW ***/

        if (productFollowCheck) {
          var $variations = $('.productoptions'),
              $productUpsell = $('.product-upsell'),
              $headerBody = $('.header-body'),
              $topRail = $('.top-rail'),
              $betaSiteSwitcher = $('#newsite-oldsite');

          // Configuration variables H in variable = height
          productFollow.init({
            productSlide: $productSlide,
            win: $win,
            variations: $variations,
            errorMessage: $variations.find('.variation-message'),
            mainButton: $variations.find('a.productbuy, button.cat-button'),
            productSlideH: $productSlide.height(),
            upsellH: $productUpsell.outerHeight(true),
            headerH: $headerBody.height(),
            topRailH: $topRail.height(),
            pageContainerH: pageContainerH,
            betaSiteSwitcherH: $betaSiteSwitcher.outerHeight(true),
            takeoverH: $takeover.outerHeight(true),
            gutterMargin: 24,
            init: true,
            initiate: true,
            speed: {
              fadein: 300,
              fadeout: 150,
              scroll: 800
            },
            algorithm: {}
          });
        }

        /*** END OF PRODUCT FOLLOW ***/
      });
    },

    _initVariableResets: function _initVariableResets($doc, $takeover, $pageContainer, anchorScrollCheck, productFollowCheck) {
      require(['anchorScroll', 'productFollow'], function (anchorScroll, productFollow) {
        /*** VARIABLE RESETS ***/

        /**
         * Detect document height change
         */
        var lastHeight = {},
            newHeight = {};
        lastHeight.doc = $doc.height();
        lastHeight.container = $pageContainer.height();
        lastHeight.takeover = $takeover.outerHeight(true);
        (function run() {
          newHeight.container = $pageContainer.height();
          newHeight.doc = $doc.height();
          newHeight.takeover = $takeover.outerHeight(true);
          if (lastHeight.doc !== newHeight.doc) {
            if (anchorScrollCheck) {
              anchorScroll.config.documentH = newHeight.doc;
            }
          }
          if (lastHeight.container !== newHeight.container) {
            if (productFollowCheck) {
              productFollow.config.pageContainerH = newHeight.container;
            }
          }
          if (lastHeight.takeover !== newHeight.takeover) {
            if (productFollowCheck) {
              productFollow.config.takeoverH = newHeight.takeover;
            }
          }
          lastHeight.doc = newHeight.doc;
          lastHeight.container = newHeight.container;
          lastHeight.takeover = newHeight.takeover;
          setTimeout(run, 400);
        })();

        /*** END OF VARIABLE RESTS ***/
      });
    },

    _initFancyBoxDefaults: function _initFancyBoxDefaults() {
      $.fancybox.defaults = $.extend($.fancybox.defaults, {
        'height': 'autoSize',
        'width': 600,
        'minWidth': 350,
        'maxWidth': 980,
        'minHeight': 20,
        'margin': 0,
        'padding': 0
      });
    },

    _initFancyBox: function _initFancyBox() {
      if ($().fancybox) {
        var $question = $('.question'),
            $fbClose = $('.fb-close'),
            $selector = $('.fb'),
            $onLoadSelector = $('.fb-onload'),
            fancybox_opts = {
          'closeBtn': false,
          'init': function init($this, markup) {
            var content;
            if (markup === true) {
              content = $this.html();
            }
            $this.fancybox({
              'content': content,
              'onComplete': function onComplete() {
                fancybox_opts.events();
              },
              'afterShow': function afterShow() {
                fancybox_opts.events();
              },
              'onClosed': function onClosed() {
                fancybox_opts.cleanup();
              }
            });
          },
          'events': function events() {
            $fbClose.on('click', function (e) {
              e.preventDefault();
              $.fancybox.close(true);
            });
          },
          'cleanup': function cleanup() {
            $question.find('[data-answer]').unbind('click');
          }
        };

        fancybox_opts.init($selector);
        fancybox_opts.init($onLoadSelector, true);
        $onLoadSelector.click();
      }
    },

    _initProductImageFancyBox: function _initProductImageFancyBox() {
      //load product image in fancybox
      $('.fb-zoom').fancybox({
        'margin': 50,
        'padding': 5,
        'arrows': false
      });
    },

    _initVideoFancyBox: function _initVideoFancyBox() {
      //fires fancybox popup video from inpage-brand-description widget image.
      if ($().fancybox) {
        $('.fb-video').fancybox({
          type: 'iframe',
          maxWidth: 800,
          maxHeight: 600,
          fitToView: false,
          width: 640,
          height: 360,
          autoSize: false,
          closeClick: false,
          openEffect: 'none',
          closeEffect: 'none'
        });
      }
    },

    _initListSortDropdown: function _initListSortDropdown($listSort) {
      //handle list sort dropdown
      if (!$('.facets-panel').length) {
        $listSort.change(function () {
          var $this = $(this);
          $this.parents('form:first').submit();
        });
      }
    },

    // configures the carouselSet module with site specific config
    _initCarouselSet: function _initCarouselSet() {
      require(['carouselSet'], function (carouselSet) {
        carouselSet.init({
          sliderDrag: true,
          sliderTouch: true,
          transitionType: 'move',
          arrowsNav: true,
          arrowsNavAutoHide: false,
          controlNavigation: 'none',
          keyboardNavEnabled: true,
          allowCSS3: true,
          loop: true,
          autoPlay: {
            enabled: false,
            pauseOnHover: true,
            delay: 6000
          }
        });
      });
    },

    // configures productSkuWidget module with site specific config
    _initProductSkuWidget: function _initProductSkuWidget() {
      require(['productSkuWidget'], function (productSkuWidget) {
        productSkuWidget.init({
          sliderDrag: true,
          sliderTouch: true,
          transitionType: 'move',
          arrowsNav: true,
          arrowsNavAutoHide: false,
          controlNavigation: 'bullets',
          keyboardNavEnabled: true,
          allowCSS3: false,
          loop: true,
          autoPlay: {
            enabled: false,
            pauseOnHover: true,
            delay: 3000
          }
        });
      });
    },

    _initLivepersonScript: function _initLivepersonScript() {
      // Liveperson
      if (siteObj.props.testApps.lp === true) {
        require(['livePerson']);
      }
    },

    _initGandalfScript: function _initGandalfScript() {
      // Gandalf
      if (siteObj.features.projectGandalf.active === true) {

        if (siteObj.sectionName === 'contact-us' || siteObj.page === 'contact-us') {
          require(['mvtBSContactP1']);
        }

        if (siteObj.page === 'customer-service') {
          require(['mvtBSContactP2']);
        }
      }
    },

    _initCustomerServiceScript: function _initCustomerServiceScript() {
      if (siteObj.sectionName === 'customer-service') {
        require(['faq']);
      }
    },

    _initAccountCreationScript: function _initAccountCreationScript() {
      // account creation page script
      if (siteObj.page === 'account-creation') {
        require(['accountCreate']);
      }
    },

    _initReviewPagingScript: function _initReviewPagingScript() {
      if (siteObj.type === 'product') {
        require(['reviewPaging']);
      }
    },

    _initLoginPageScript: function _initLoginPageScript() {
      // login page scripts
      if (siteObj.page === 'login') {
        require(['loginPage']);
      }
    },

    _mediaTablet: function _mediaTablet(bodyWrap) {
      if (window.innerWidth || document.documentElement.clientWidth < 1365) {
        return bodyWrap.attr('id', 'media-tablet');
      }
      return bodyWrap.attr('id', '');
    },

    /**
     * Detect if the element is fully within the window
     * @param object
     */
    _elementOnScreen: function _elementOnScreen(object) {
      var documentViewTop = $(window).scrollTop(),
          objectTop = $(object).offset().top;
      return objectTop <= documentViewTop + (window.innerHeight || document.documentElement.clientHeight) && objectTop >= documentViewTop;
    },

    /**
     * Animate the review bars
     * @param chartBars
     */
    _animateReview: function _animateReview(chartBars) {
      chartBars.removeClass('no-transition').each(function () {
        $(this).css({
          width: $(this).data('width')
        });
      });
    },

    /**
     * Chart bar check
     * @param chartHolder
     * @param chartBars
     */
    _chartBarCheck: function _chartBarCheck(chartHolder, chartBars) {
      if (zvint._elementOnScreen(chartHolder)) {
        zvint._animateReview(chartBars);
      } else {
        chartBars.addClass('no-transition').css({
          width: 0
        });
      }
    },

    _init: function _init() {

      var $body = $('body'),
          tabs = $('.mtabs, #tabs'),

      // Initial HTML markup to be added into Fancybox. Contains the loading spinner and hidden close button.
      initial_fb_content = '<div class="basketAlert"><img src="' + siteObj.siteNonSecureURL + 'common/images/loading.gif" alt="Loading" class="fb-loader" /></div>',
          $listSort = $('.list-sort select'),
          $reviewStars = $('.has-reviews .link'),
          $customerReviews = $('#customer-reviews'),
          $bannerLinks = $('.media-block');

      zvint._initBannerWidgets($bannerLinks);

      zvint._initCountdownTimer();

      zvint._initIE8ish();

      zvint._initCurrencySelector();

      zvint._initListPageVariations($body, initial_fb_content);

      zvint._initFancyBoxDefaults();

      zvint._initProductImageFancyBox();

      zvint._initVideoFancyBox();

      zvint._initProductPage($reviewStars, $customerReviews);

      zvint._initReadMore($body);

      zvint._initTabs(tabs);

      zvint._initListSortDropdown($listSort);

      zvint._initHelpSitePopup($body);

      zvint._initTooltipPopups();

      zvint._initMediaVideo();

      zvint._initFancyBox();

      zvint._initFullWidthVideo();

      zvint._initDescriptionTab();

      /*** Variables for dynamic AMD JavaScript below - (Bugs or Queries? Tom S FED Build Team) ***/

      var $pageContainer = $('.primary-wrap'),
          pageContainerH = $pageContainer.height(),
          $doc = $(document),
          documentH = $doc.height(),
          $win = $(window),
          $takeover = $('[data-component="takeoverWidget"]'),
          supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints || window.DocumentTouch && document instanceof DocumentTouch,
          $backToTop = $('.back-to-top');

      var anchorScrollCheck = $backToTop.length;
      var $chartHolder = $('.rating-graph-container');
      var scoreHolderCheck = $chartHolder.length;
      var $chartBars = $chartHolder.find('.review-bar');
      var $productSlide = $('.product-summary');
      var productFollowCheck = $productSlide.length && !$productSlide.find('.soldout').length;
      var mediaMatch = window.matchMedia || window.msMatchMedia,
          bodyWrap = $('.body-wrap');

      zvint._initWidgetControls(supportsTouch);

      zvint._initStickyHeader($pageContainer, $win, supportsTouch, documentH);

      zvint._initAnchorScroll(anchorScrollCheck, $backToTop, $win, supportsTouch, documentH);

      zvint._initWindowScroll(supportsTouch, anchorScrollCheck, productFollowCheck, scoreHolderCheck, $chartHolder, $chartBars);

      zvint._initProductFollow(productFollowCheck, $win, $productSlide, $takeover, pageContainerH);

      zvint._initVariableResets($doc, $takeover, $pageContainer, anchorScrollCheck, productFollowCheck);

      if (supportsTouch) {
        $body.addClass('supports-touch');
      }

      zvint._initTabChart();

      zvint._initRoyalSliderPlus();

      zvint._initProductReview(scoreHolderCheck, $chartHolder, $chartBars);

      zvint._initResize(mediaMatch, bodyWrap);

      zvint._initCodes($doc, bodyWrap, $body);

      // Find product images, check they exist and apply the fancybox functionality to them
      var productDetailsImage = $('.tabs .product-details-image, .productDescription_synopsisContent .product-details-image');

      if (productDetailsImage.length) {
        productDetailsImage.fancybox();
      }

      zvint._initProductPap();

      zvint._initCarouselSet();

      zvint._initProductSkuWidget();

      zvint._initAccountCreationScript();

      zvint._initReviewPagingScript();

      zvint._initLoginPageScript();

      zvint._initLivepersonScript();

      zvint._initGandalfScript();

      zvint._initCustomerServiceScript();

      zvint._initYouTube();

      /* Javascript Healthcheck - Please keep this at the bottom of the file. */
      var healthCheck = document.createElement('span');
      healthCheck.id = 'jshealthcheck';
      document.body.appendChild(healthCheck);
    }
  };

  zvint._init();
  return zvint;
});
//# sourceMappingURL=zvint.js.map
